export var isJinx = process.env && process.env.VUE_APP_RUNTIME_ENV && ['admin', 'jinx'].includes(process.env.VUE_APP_RUNTIME_ENV);
export var isJinxStaging = window.location.href.includes('staging') && isJinx;
export var isJinxPrt = window.location.href.includes('corp') && isJinx; // 是否是生产h5域名

export var judgeIsCreativePage = function judgeIsCreativePage(url) {
  var Url = new URL(url);
  return ['m-creative.kwai.com', 'm-creative.kslawin.com'].includes(Url.hostname) && Url.pathname.startsWith('/creator/');
};